var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowDonationModal)?_c('DonationModal',{on:{"close":function($event){_vm.isShowDonationModal = false},"clickOutsideBody":_vm.dismissDonationModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }